/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { useApi } from '../services';

export const useGetAccessRoleById = (idRole) => useApi(`v2/access-role/${idRole}`, 'GET', {}, {}, true);

export const useAccessRoleClone = (idRole) => useApi(`v2/access-role/${idRole}/clone`, 'POST', {}, {});

export const useAccessRoleExpire  = (idRole) => useApi(`v2/access-role/${idRole}/expire`, 'DELETE', {}, {});

export const useAccessRoleRestore  = (idRole) => useApi(`v2/access-role/${idRole}/restore`, 'PATCH', {}, {});
